import React, { createContext, useContext, useState, useEffect } from 'react';

const LocationContext = createContext();

// Default location: Jakarta
const DEFAULT_LOCATION = {
  lat: -6.2830519,
  lon: 106.8089839,
  name: "Jakarta, Indonesia"
};

export const LocationProvider = ({ children }) => {
  // Directly use DEFAULT_LOCATION as initial state
  const [location, setLocation] = useState(DEFAULT_LOCATION);
  const [isDetecting, setIsDetecting] = useState(false); // No detection needed
  const [error, setError] = useState(null);

  useEffect(() => {
    // Skip detection as requested
    // detectLocation();
  }, []);

  const detectLocation = () => {
    // Force default location logic
    setLocation(DEFAULT_LOCATION);
    setIsDetecting(false);
    setError(null);
  };

  return (
    <LocationContext.Provider value={{
      location,
      setLocation,
      isDetecting,
      error,
      detectLocation
    }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
};
